module.exports = __webpack_public_path__ + "img/main_ranking_1st.eb76e96.png";